import React from "react";

export const LoadingSpinner = () => (
    <i className="icon ion-ios7-reloading loading" />
);
